import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesCommentsByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesCommentsByIdPatchAsyncSlice } from './patch';

export const coreInitiativesCommentsByIdReducers = combineReducers({
	delete: coreInitiativesCommentsByIdDeleteAsyncSlice.asyncReducers,
	patch: coreInitiativesCommentsByIdPatchAsyncSlice.asyncReducers
});

export const coreInitiativesCommentsByIdWatchers = combineAllWatchers([
	coreInitiativesCommentsByIdDeleteAsyncSlice.asyncWatchers,
	coreInitiativesCommentsByIdPatchAsyncSlice.asyncWatchers
]);
